/*
 *   File : kyc.js
 *   Author URI : https://evoqins.com
 *   Description : Navigation screen which holds all four steps in the KYC registration flow.
 *   Integrations : null
 *   Version : v1.1
 */

import { Fragment, useEffect, useState } from "react";
import Store from "../../Store";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

import { BreadCrumb } from "../../Component/BreadCrumb"
import { InvestmentHeader } from "../../Component/Header"
import Icon from "../../Component/Icon/icon";
import Footer from "../../Component/Footer/footer";
// import AddressDetail from "./address-detail";
import LandingPage from "./helper/landing";
import AccountTypesPage from "./helper/account-types";
import KYCStatusPage from "./helper/kyc-status";
import PANDetailsPage from "./helper/pan-details";
import PersonalDetailsPage from "./helper/personal-details";
import DeclarationsPage from "./helper/declaration";
import IPVPage from "./helper/ipv";
import KYCStatus from "./helper/status";
import NomineePage from "./helper/nominee";
import BankDetail from "./bank";
import UploadDeclaration from "./helper/declaration-upload";
import DigitalEsign from "./helper/digital-esign";
import SubmissionReview from "./helper/review";
import PreviewPage from "./helper/preview";
import CreateBank from "./helper/create-bank";
import { CustomLoader } from "../../Component/Other";

import APIService from "../../Service/api-service";
import { _getKycProfile } from "../../Helper/api";

import Colors from '../../Styles/color.module.scss';
import MinorPANDetailsPage from "./helper/minor-pan-detail";
import MinorBankDetail from "./helper/minor-bank-details";
import VerifyNRINumber from "./helper/NRI/verify-number";
import NRIPANDetailsPage from "./helper/NRI/pan-details";
import NRIPersonalDetailsPage from "./helper/NRI/personal-details";
import NRIAddressDetailsPage from "./helper/NRI/address-details";
import NRITaxDetailsPage from "./helper/NRI/tax-details";
import NRIBankDetail from "./helper/NRI/bank-detail";
import SubmitNRIKyc from "./helper/NRI/submit-kyc";

const PAGE_NAVIGATION = [
    { page: 'Home', url: '/' },
    { page: 'Account opening', url: null },
];


const KYC = () => {

    const [progress, setProgress] = useState(0);
    console.log('progress', progress);

    const [accountType, setAccountType] = useState("");
    console.log('accountType', accountType);

    const [isManual, setIsManual] = useState(false);

    console.log('isManual', isManual);

    const [backNavigation, setBackNavigation] = useState(false);
    const [loader, setLoader] = useState(true);
    const [digioToken, setDigioToken] = useState('');
    const [kycData, setKycData] = useState({});
    const [submitKycType, setSubmitKycType] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    useEffect(() => {
        _getKYCProgress();
        _getKycGeneralData();
    }, [])

    // scroll to top
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [progress]);

    const _updateProgress = (value, text = accountType, is_manual = isManual, is_edit = false, digio_token = null) => {
        console.log('is_manual', is_manual);

        setProgress(value);
        setAccountType(text);
        // if (text !== "Individual") {
        //     setIsManual(true);
        // } else {
        //     setIsManual(false);
        // }
        setIsManual(is_manual);
        if (digio_token !== null) {
            setDigioToken(digio_token);
        }
    }

    function _navigateBack() {
        if (progress >= 1) {
            if (submitKycType === true) {
                setProgress(9);
                setSubmitKycType(false);
            } else {
                setProgress(progress - 1);
            }
        }
        setBackNavigation(true);
    }

    // API - get kyc general data
    function _getKycGeneralData() {
        let url = 'kyc/general-data';
        APIService(false, url).then((response) => {
            if (response.status_code === 200) {
                Store.dispatch({
                    type: 'KYC_CATEGORIES',
                    payload: response.data
                });
            }
        })
    }

    // API :: get kyc progress
    const _getKYCProgress = async () => {
        try {
            const kyc_data = await _getKycProfile();
            setKycData(kyc_data);
            setIsEdit(kyc_data.is_review);
            setAccountType(kyc_data.onboarding_sub_type ?? "")
            // if (kyc_data.onboarding_sub_type !== "Individual") {
            //     setIsManual(true);
            // } else {
            //     setIsManual(false);
            // }

            setIsManual(kyc_data.nri_info.is_manual ?? false);
            if (kyc_data.kyc_step === 0) {
                // if (Object.keys(kyc_data).length !== 0 && kyc_data.email !== null && kyc_data.mobile !== null) {
                //     console.log("Why here")
                //     setProgress(2);
                // }
                // else {
                if (kyc_data.nri_info.foreign_verified === true && kyc_data.onboarding_type === "NRI") {
                    setProgress(3);
                } else {
                    setProgress(kyc_data.kyc_step + 1)
                    console.log('kyc_data', kyc_data.kyc_step);

                }

                // }
            }
            else
                if (kyc_data.kyc_step < 9) {
                    if (kyc_data.onboarding_sub_type === "HUF") {
                        if (kyc_data.signup_progress_text === "PAN_ADDED") {
                            setProgress(3);
                        } else if (kyc_data.signup_progress_text === "PERSONAL_DETAILS_ADDED") {
                            setProgress(4);
                        } else if (kyc_data.signup_progress_text === "DECLARATIONS_ADDED") {
                            setProgress(5);
                        } else if (kyc_data.signup_progress_text === "BANK_ADDED") {
                            setProgress(6);
                        } else if (kyc_data.signup_progress_text === "NOMINEE_ADDED") {
                            setProgress(6);
                        } else if (kyc_data.signup_progress_text === "ESIGN_REQUIRED") {
                            setProgress(7);
                        } else {
                            setProgress(8);
                        }
                    }
                    else if (kyc_data.onboarding_sub_type === "Minor") {
                        if (kyc_data.signup_progress_text === "PAN_ADDED") {
                            setProgress(3);
                        } else if (kyc_data.signup_progress_text === "DECLARATIONS_ADDED") {
                            setProgress(4);
                        } else if (kyc_data.signup_progress_text === "BANK_ADDED") {
                            setProgress(5);
                        } else if (kyc_data.signup_progress_text === "ESIGN_REQUIRED") {
                            setProgress(5);
                        } else {
                            setProgress(6);
                        }
                    }
                    else if (kyc_data.onboarding_sub_type === "NRI") {
                        if (kyc_data.signup_progress_text === "FOREIGN_NUMBER_ADDED") {
                            setProgress(3)
                        }
                        else if (kyc_data.signup_progress_text === "PAN_ADDED") {
                            setProgress(4);
                        } else if (kyc_data.signup_progress_text === "PERSONAL_DETAILS_ADDED") {
                            setProgress(5);
                        }
                        else if (kyc_data.signup_progress_text === "ADDRESS_ADDED") {
                            setProgress(6);
                        }
                        else if (kyc_data.signup_progress_text === "DECLARATIONS_ADDED") {
                            setProgress(7);
                        }
                        else if (kyc_data.signup_progress_text === "BANK_ADDED") {
                            setProgress(8);
                        }
                        else if (kyc_data.signup_progress_text === "NOMINEE_ADDED") {
                            setProgress(9);
                        }
                        // else if (
                        //     kyc_data.signup_progress_text === (isManual ? "KYC_SUBMITTED" : "IPV_ADDED")
                        // ) {
                        //     setProgress(10);
                        // }
                        else if (
                            kyc_data.signup_progress_text === "ESIGN_REQUIRED" ||
                            kyc_data.signup_progress_text === "IPV_ADDED"
                        ) {
                            setProgress(10);
                        }
                        else {
                            setProgress(11);
                        }
                    }
                    else {
                        setProgress(kyc_data.kyc_step + 2)
                    }
                }
                else {
                    if (kyc_data.signup_progress_text === "ADMIN_REJECTED" || kyc_data.signup_progress_text === "KYC_REJECTED") {
                        setProgress(2);
                    } else {
                        if (kyc_data.onboarding_sub_type === "NRI") {
                            setProgress(kyc_data.kyc_step + 2)
                        } else {
                            setProgress(kyc_data.kyc_step + 1)
                        }
                    }
                }
            setLoader(false);
        } catch (error) {
            toast.dismiss();
            toast.error(error, {
                type: "error"
            });
        }
    };


    function KYCProgress() {
        return (
            <div className="">
                <p className="color-outer-space e-poppins-regular e-font-16 margin-block-end-0 my-2">{`Step ${progress} of ${accountType == "NRI" ? 10 : accountType == "Minor" ? "5" : accountType === "HUF" ? "8" : "9"}`}</p>
                <div className="d-flex mb-4">
                    {Array.from({ length: accountType === "Minor" ? 5 : accountType === "HUF" ? 8 : accountType === "NRI" ? 10 : 9 }, (_, key) => (
                        <div key={key} className="bg-sliver-gray border-radius-4px position-relative e-kyc-progress-track me-1">
                            <div
                                className="bg-ocean-boat-blue border-radius-4px position-absolute e-kyc-progress-bar top-0 left-0"
                                data-completed-step={progress >= key + 1 ? true : false} // Completed step 
                                data-completing-step={progress === key + 1 && backNavigation === false ? true : false} // next step progress animation
                                data-prev-step={backNavigation && progress === key} // prev step progress animationś
                            ></div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }


    return (
        loader === true ?
            <CustomLoader />
            :
            <Fragment>
                <div className="e-kyc e-page-container margin-72px-bottom">
                    {/* Header */}
                    <InvestmentHeader />

                    {/* Breadcrumb */}
                    <BreadCrumb data={PAGE_NAVIGATION} />
                    {/* <p className="color-black e-poppins-medium e-font-20 line-height-32px my-4">Account opening</p> */}
                    {
                        progress === 0 ?
                            <LandingPage updateProgress={_updateProgress} />
                            :
                            <div className="row">
                                <div className="col-12 ">
                                    {
                                        isEdit === false ?
                                            <div className="mt-4 mb-2 py-2">
                                                {(progress > (accountType === "HUF" ? 2 : accountType === "Minor" ? 2 : accountType === "NRI" ? 4 : 3) && progress < (accountType === "Minor" ? 6 : accountType === "HUF" ? 9 : 10)) && <button className="color-black e-poppins-medium e-font-16 e-kcy-back-button bg-transparent no-border no-outline"
                                                    onClick={_navigateBack}>
                                                    <Icon icon="back-arrow"
                                                        size={24}
                                                        className="me-2"
                                                        color={Colors.black} />
                                                    Back to previous step
                                                </button>}
                                            </div>
                                            :
                                            null
                                    }

                                    {(progress < (accountType === "NRI" ? 10 : 9) && progress > 1) && <KYCProgress />}

                                    {
                                        progress === 1 ?
                                            <LandingPage updateProgress={_updateProgress} />
                                            : progress === 2 ?
                                                accountType === "NRI" ?
                                                    <VerifyNRINumber edit={isEdit} updateProgress={_updateProgress} />
                                                    :
                                                    accountType === "Minor" ?
                                                        <MinorPANDetailsPage edit={isEdit} updateProgress={_updateProgress} />
                                                        :
                                                        <PANDetailsPage updateProgress={_updateProgress} text={accountType} is_manual={isManual} />
                                                : progress === 3 ?
                                                    accountType === "NRI" ?
                                                        <NRIPANDetailsPage edit={isEdit} updateProgress={_updateProgress} />
                                                        :
                                                        accountType === "Minor" ?
                                                            <DeclarationsPage edit={isEdit} is_manual={isManual} text={accountType} updateProgress={_updateProgress} />
                                                            :
                                                            <KYCStatusPage edit={isEdit} updateProgress={_updateProgress} is_manual={isManual} text={accountType} />
                                                    : progress === 4 ?
                                                        accountType === "NRI" ?
                                                            <NRIPersonalDetailsPage edit={isEdit} updateProgress={_updateProgress} />
                                                            :
                                                            accountType === "Minor" ?
                                                                <MinorBankDetail edit={isEdit} updateProgress={_updateProgress} is_manual={isManual} text={accountType} />
                                                                :
                                                                accountType === "HUF" ?
                                                                    <DeclarationsPage edit={isEdit} updateProgress={_updateProgress} is_manual={isManual} text={accountType} />
                                                                    :
                                                                    <PersonalDetailsPage edit={isEdit} updateProgress={_updateProgress} />
                                                        : progress === 5 ?
                                                            accountType === "NRI" ?
                                                                <NRIAddressDetailsPage edit={isEdit} updateProgress={_updateProgress} />
                                                                :
                                                                accountType === "Minor" ?
                                                                    <PreviewPage is_manual={isManual} text={accountType} type={2} updateProgress={_updateProgress} />
                                                                    :
                                                                    accountType === "HUF" ?
                                                                        <BankDetail edit={isEdit} updateProgress={_updateProgress} is_manual={isManual} text={accountType} />
                                                                        :
                                                                        <DeclarationsPage edit={isEdit} is_manual={isManual} text={accountType} updateProgress={_updateProgress} />
                                                            :
                                                            accountType === "Minor" ?
                                                                <KYCStatus />
                                                                :
                                                                progress === 6 ?
                                                                    accountType === "NRI" ?
                                                                        <NRITaxDetailsPage edit={isEdit} updateProgress={_updateProgress} />
                                                                        :
                                                                        accountType === "HUF" ?
                                                                            <UploadDeclaration edit={isEdit} is_manual={isManual} text={accountType} updateProgress={_updateProgress} />
                                                                            :
                                                                            <CreateBank edit={isEdit} updateProgress={_updateProgress} />
                                                                    :
                                                                    progress === 7 ?
                                                                        accountType === "NRI" ?
                                                                            <NRIBankDetail edit={isEdit} updateProgress={_updateProgress} />
                                                                            :
                                                                            accountType === "HUF" ?
                                                                                <DigitalEsign edit={isEdit} is_manual={isManual} text={accountType} updateProgress={_updateProgress} />
                                                                                :
                                                                                <NomineePage edit={isEdit} updateProgress={_updateProgress} />
                                                                        :
                                                                        progress === 8 ?
                                                                            accountType === "NRI" ?
                                                                                <NomineePage edit={isEdit} updateProgress={_updateProgress} />
                                                                                :
                                                                                accountType === "HUF" ?
                                                                                    <PreviewPage is_manual={isManual} text={accountType} updateProgress={_updateProgress} digioToken={digioToken} />
                                                                                    :
                                                                                    <IPVPage text={accountType} updateProgress={_updateProgress} />
                                                                            :
                                                                            progress === 9 ?
                                                                                accountType === "NRI" ?
                                                                                    <SubmitNRIKyc edit={isEdit}
                                                                                        back={backNavigation}
                                                                                        updateProgress={_updateProgress}
                                                                                        submitKycType={() => {
                                                                                            setSubmitKycType(true);
                                                                                            setBackNavigation(false);
                                                                                        }} />
                                                                                    :
                                                                                    accountType === "HUF" ?
                                                                                        <KYCStatus updateProgress={_updateProgress} />
                                                                                        :
                                                                                        <PreviewPage is_manual={isManual} text={accountType} updateProgress={_updateProgress} digioToken={digioToken} />

                                                                                :
                                                                                progress === 10 ?
                                                                                    accountType === "NRI" ?
                                                                                        <PreviewPage edit={isEdit} accountType={accountType} text={accountType} is_manual={isManual} updateProgress={_updateProgress} />
                                                                                        :
                                                                                        <KYCStatus updateProgress={_updateProgress} />
                                                                                    :
                                                                                    <KYCStatus updateProgress={_updateProgress} />


                                    }
                                </div>
                            </div>
                    }
                </div>
                <Footer />
            </Fragment >
    )
}

export default KYC
